export default "__VITE_ASSET__D6U1GKUi__"